import React from 'react';
import DisplayConfiguration from './DisplayConfiguration';

const Display50Pct50Pct = props => {
  const styles = Object.freeze([{},{}]);

  return <DisplayConfiguration {...props} styles={styles} className="display-50-50" />;
};

export default Display50Pct50Pct;
